import { setActiveLanguage } from 'react-localize-redux';

export function changeLanguage(lng) {
  return (dispatch) => {
    dispatch(setActiveLanguage(lng));
  }
}
